// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"72731ad4","329":"83d6180f","588":"321ef752","696":"007b09ff","963":"54ab6b33","980":"4cc62472"}[chunkId] + ".chunk.js";
};